// onelogin-roller
export const piggavAdmin = "piggav-admin";
export const piggavKunde = "piggav-kunde";
export const piggavPocketcontrol = "piggav-pocketcontrol";
export const piggavServiceavdeling = "piggav-serviceavdeling";
export const piggavResepsjon = "piggav-resepsjon";
export const piggavBilIOslo = "piggav-bilioslo";
export const piggavLesebruker = "piggav-lesebruker";
